module.exports = __webpack_public_path__ + "img/type - Copy.67e9b0b4.svg";